function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_12349_96764)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1998 22H15.8C18.0091 22 19.8 20.2091 19.8 18V4C19.8 1.79086 18.0091 0 15.8 0H4C1.79086 0 0 1.79086 0 4V18C0 20.2091 1.79086 22 4 22H5.60022H9.9H14.1998ZM14 20C16.2091 20 18 18.2091 18 16V11V6.5V6C18 3.79086 16.2091 2 14 2H6C3.79086 2 2 3.79086 2 6V11V16C2 18.2091 3.79086 20 6 20H14Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 6C4 5.44772 4.44772 5 5 5H15C15.5523 5 16 5.44772 16 6C16 6.55228 15.5523 7 15 7H5C4.44772 7 4 6.55228 4 6Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 10.0004C4 9.44811 4.44772 9 5 9H7.59998H9.6C10.1523 9 10.6 9.44811 10.6 10.0004C10.6 10.5527 10.1523 11.0008 9.6 11.0008H5C4.44771 11.0008 4 10.5527 4 10.0004Z",
  fill: "#18CDA6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 14C4 13.4477 4.44772 13 5 13H12.9C13.4523 13 13.9 13.4477 13.9 14C13.9 14.5523 13.4523 15 12.9 15H9H5C4.44772 15 4 14.5523 4 14Z",
  fill: "#18CDA6"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_12349_96764"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.8,
  height: 22,
  fill: "white"
})));

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.0a9c2466.svg";
export { ForwardRef as ReactComponent };